import { useRef } from "react";
import ImageIcon from '@mui/icons-material/Image';
import ClearIcon from '@mui/icons-material/Clear';
import DropBox, { DropBoxProps } from "./drop-box";
import { IconButton, Stack } from "@mui/material";
import { Image } from "@/components/display";
import EmptyContent from "./empty-content";
import FileInputBase from "./file-input-base";
import { parseListToFileList } from "./utils";

export interface ImageFieldProps extends Omit<DropBoxProps, "children" | "value" | "onChange"> {
    value?: File | null,
    onChange?: (e: React.SyntheticEvent, v: File | null) => any,
    disabled?: boolean,
}

export default function ImageField({
    value,
    onChange,
    ...props
}: ImageFieldProps) {
    const fileInputRef = useRef<HTMLInputElement>(null!);

    const openFileSelect = () => {
        fileInputRef.current.click();
    }

    const handleChange = (e: React.SyntheticEvent, v: FileList | null) => {
        if (!onChange) return;
        onChange(e, v?.item(0) || null);
    }

    const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
        handleChange(e, e.dataTransfer.files);
    }

    const handleRemove = (e: React.SyntheticEvent) => {
        handleChange(e, null);
    }

    return <>
        <DropBox
            {...props}
            position={"relative"}
            border={"1px dashed"}
            borderRadius={"10px"}
            onDrop={e => {
                props.onDrop && props.onDrop(e);
                handleDrop(e);
            }}
        >
            {value == null ? <EmptyContent
                onButtonClick={openFileSelect}
                dragText={"Arrastra aquí la Imagen."}
                buttonText={"Seleccionar Imagen"}
                Icon={ImageIcon}
                disabled={props.disabled}
            /> : <ValidContent
                value={value}
                disabled={props.disabled}
                handleRemoveFile={e => handleRemove(e)}
            />}
        </DropBox>
        <FileInputBase
            ref={fileInputRef}
            hidden
            value={value ? parseListToFileList([value]) : null}
            onChange={handleChange}
            accept="image/*"
            disabled={props.disabled}
        />
    </>
}

function ValidContent({ value, handleRemoveFile, disabled }: {
    value: File,
    handleRemoveFile?: (e: React.SyntheticEvent) => void,
    disabled?: boolean
}) {
    return <Stack
        position={"absolute"} top={0} bottom={0} left={0} right={0}
        alignItems={"center"} justifyContent={"center"}
    >
        <Image src={value} maxWidth={"100%"} maxHeight={"100%"} />
        <IconButton
            sx={{ position: "absolute", top: "5px", right: "5px", backgroundColor: "background.default" }}
            disabled={disabled}
            onClick={handleRemoveFile}
        >
            <ClearIcon />
        </IconButton>
    </Stack>
}